import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Badge as AntdBadge } from 'antd';
import { injectIntl } from 'react-intl';
import { withRouter } from 'utils/withRouter';
import HeaderButton from '../../header/components/header-button';

const Badge = styled(AntdBadge)`
  .ant-badge-count {
    height: 15px;
    min-width: 15px;
    top: 9px;
    right: 22px;
    font-size: 11px;
    z-index: 0;
    line-height: 15px;
  }

  .ant-scroll-number-only {
    margin-top: -2px;
    margin-left: 0;
  }
`;

const SystemHeaderButton = styled(HeaderButton)`
  border-right: 1px solid ${p => p.theme.colors.border};
  transition: all 0.3s ease-out;
`;

class SystemMessageButton extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectUrl && nextProps.redirectUrl !== this.props.redirectUrl) {
      // this.setState({ visible: false });
      this.props.history.push(nextProps.redirectUrl);
    }
  }

  render() {
    const { messageCount, intl } = this.props;
    return (
      <>
        <div onClick={() => this.props.toggleMessageCenter(true)}>
          <Badge count={messageCount}>
            <SystemHeaderButton
              icon='bell'
              light={true}
              text={intl.formatMessage({ id: 'common.labels.MESSAGE_CENTER' })}
              hasMessages={!!messageCount}
              borderLeft
            />
          </Badge>
        </div>
      </>
    );
  }
}

SystemMessageButton.propTypes = {
  messageCount: PropTypes.number,
  redirectUrl: PropTypes.string,
  history: PropTypes.object,
  intl: PropTypes.object,
  toggleMessageCenter: PropTypes.func,
};

export default injectIntl(withRouter(SystemMessageButton));
